export default __webpack_public_path__ + "static/OF_logo_R-2dfbf236ef0f4e34adc9cf1c0ed0443b.svg";